import React, { useEffect } from "react";
import { GridStack } from "gridstack";
import GridItem from "../../../../Components/UiComponents/GridItem/GridItem";
import DMSHeader from "../../DMSHeader/DMSHeader";
import { useTranslation } from "react-i18next";
import CreateBankForm from "./CreateBankForm";
import { useLocation } from "react-router-dom";

// Component for rendering create/edit Bank form 
const BankForm = () => {
  const { t } = useTranslation();
  const { state } = useLocation();
  // Check if component is in edit mode
  let edit = state?.edit;

  // Initialize GridStack on component mount
  useEffect(() => {
    GridStack.init();
  }, []);

  // Grid layout configuration with header and form sections
  const layoutData = [
    {
      x: 0,
      y: 0,
      width: 12,
      height: 1,
      id: 0,
      component: (
        <DMSHeader
          title={edit ? t("Edit Bank details") : t("Add Bank details")} // Dynamic title based on edit mode
          showIconsForback={true}
        />
      ),
      haveOverflowVisible: true,
    },
    {
      x: 0,
      y: 1,
      width: 12,
      height: 13,
      id: 1,
      component: <CreateBankForm />,
    },
  ];

  return (
    <div className="grid-stack grid-stack-instance-1 smartpole__header--transition">
      {/* Render grid items based on layout configuration */}
      <GridItem layoutData={layoutData} />
    </div>
  );
};

export default BankForm;
